export default {
  isEmpty: (state) => state.items.length === 0
}
